import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=492765a6&"
import script from "./Permits.vue?vue&type=script&lang=ts&"
export * from "./Permits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports